import React from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    backgroundColor: theme.palette.background.default,
    border: props.border ? `solid 1px ${theme.palette.grey.veryLight}` : null,
    borderRadius: props.border ? 5 : null,
  }),
}))

const GreyBox = ({ children, border = false }) => {
  const classes = useStyles({ border })
  return <div className={clsx(classes.root, 'px-16 py-20')}>{children}</div>
}

export default GreyBox
